<template>
  <div class="page-wrapper">
    <ul class="step">
      <li :class="{ 'active': companyRegStep === 1 }" class="step-item marginRight">
        <span>安全验证</span>
        <img class="step_icon" :src="img1" alt="">
      </li>
      <li :class="{ 'active': companyRegStep === 2 }" class="step-item marginRight">
        <span>设置新密码</span>
        <img class="step_icon" :src="img2" alt="">
      </li>
      <li :class="{ 'active': companyRegStep === 3 }" class="step-item">
        <span>设置成功</span>
        <img class="step_icon" :src="img3" alt="">
      </li>
    </ul>
    <!-- 密码重置第一步 -->
    <div v-show="companyRegStep === 1" class="form-wrapper">
      <el-form ref="ruleForm_c1" :model="ruleForm_c1" :rules="rules" label-width="426px" :hide-required-asterisk="true">
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="ruleForm_c1.phone" placeholder="请输入正确的手机号码" maxlength="11" :disabled="phoneClock" style="width: 330px" clearable></el-input>
        </el-form-item>
        <el-form-item class="rd-code" label="图形验证码" prop="imgCode">
          <el-input v-model="ruleForm_c1.imgCode" placeholder="请输入右侧图形验证码" maxlength="6" clearable></el-input>
          <img class="imgCode" :src="imgCodeSrc" alt="图形验证码" @click="getImgCode">
        </el-form-item>
        <el-form-item class="rd-code" label="短信验证码" prop="code">
          <el-input v-model="ruleForm_c1.code" placeholder="请输入短信验证码" maxlength="6" clearable></el-input>
          <div class="msgCode" :class="{ 'disabled': phoneClock }" @click="handleBtnClick_sendCode">{{ msgCodeText }}</div>
        </el-form-item>
      </el-form>
      <rd-button class="btn" text="下一步" :loading="btnLoading_c1" @click="handleBtnClick_Submit_c1"></rd-button>
    </div>

    <!-- 密码重置第二步 -->
    <div v-show="companyRegStep === 2" class="form-wrapper">
      <el-form ref="ruleForm_c2" :model="ruleForm_c2" :rules="rules" label-width="426px" :hide-required-asterisk="true">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="ruleForm_c2.password" :type="password" placeholder="设新密码，8-16位字母、数字组成" maxlength="16" clearable>
            <span class="suffix" slot="suffix">
              <img v-show="password === 'password'" class="imgSee" src="../../assets/img/icon/view_off.png" alt="" @click="handleIconClick('password')">
              <img v-show="password === 'text'" class="imgNo" src="../../assets/img/icon/view.png" alt="" @click="handleIconClick('password')">
            </span>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="ruleForm_c2.confirmPwd" :type="confirmPwd" placeholder="重复上方输入的密码" maxlength="16" clearable>
            <span class="suffix" slot="suffix">
              <img v-show="confirmPwd === 'password'" class="imgSee" src="../../assets/img/icon/view_off.png" alt="" @click="handleIconClick('confirmPwd')">
              <img v-show="confirmPwd === 'text'" class="imgNo" src="../../assets/img/icon/view.png" alt="" @click="handleIconClick('confirmPwd')">
            </span>
          </el-input>
        </el-form-item>
      </el-form>
      <rd-button class="btn" text="下一步" :loading="btnLoading_c2" @click="handleBtnClick_Submit_c2"></rd-button>
    </div>

    <!-- 密码重置成功 -->
    <div v-show="companyRegStep === 3" class="form-wrapper">
      <div class="rd-success">
        <img class="pic_success" src="../../assets/img/icon/icon-cg.png" alt="成功">
        <label>密码重置成功</label>
        <span><i>{{ second }}</i> 秒后自动跳转至 <b @click="routerGo('login')">登录页</b></span>
      </div>
    </div>
  </div>
</template>

<script>
  import * as ajaxUrl from '../../ajax.config.js';
  import msgCodeBtnClick from '../../mixins/msgCodeBtnClick.js';
  import formValidator from '../../mixins/formValidator.js';
  import { regexEmail, regexPhone, regexPwd } from '../../mixins/formRules';
  import RdButton from '../../components/Button/Button.vue';
  import icon1Sel from '../../assets/img/icon/1.png';
  import icon2Nor from '../../assets/img/icon/22.png';
  import icon3Nor from '../../assets/img/icon/33.png';
  import { encrypt } from '@/util/rsaEncrypt';
  import iconYiwancheng from '../../assets/img/icon/0.png';
  import icon2Sel from '../../assets/img/icon/2.png';
  import icon3Sel from '../../assets/img/icon/3.png';

  export default {
    name: 'forget',
    data() {
      return {
        password: 'password',
        confirmPwd: 'password',
        companyRegStep: 1, // 企业注册步骤
        img1: icon1Sel,
        img2: icon2Nor,
        img3: icon3Nor,
        second: 3,
        timer: '',
        imgCodeSrc: '',
        dialog_regSuccess: false,
        btnLoading_p: false,
        btnLoading_c1: false,
        btnLoading_c2: false,
        loginType: '',
        ruleForm_c1: {
          phone: '',
          code: '',
          imgCode: '',
          uuid: ''
        },
        ruleForm_c2: {
          password: '',
          confirmPwd: ''
        },
        rules: {
          phone: [
            { validator: regexPhone, trigger: ['blur', 'change'] }
          ],
          email: [
            { validator: regexEmail, trigger: ['blur', 'change'] }
          ],
          code: [
            { required: true, message: '请输入短信验证码', trigger: ['blur', 'change'] }
          ],
          imgCode: [
            { required: true, message: '请输入图形验证码', trigger: ['blur', 'change'] }
          ],
          password: [
            { validator: regexPwd, trigger: ['blur', 'change'] }
          ],
          confirmPwd: [
            { validator: regexPwd, trigger: ['blur', 'change'] }
          ]
        }
      };
    },
    components: { RdButton },
    mixins: [msgCodeBtnClick, formValidator],
    mounted() {
      this.getImgCode();
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.judgeAccess(from.params.login_type);
      });
    },
    methods: {
      handleIconClick(str) {
        this[str] = this[str] === 'password' ? 'text' : 'password';
      },
      judgeAccess(val) {
        this.loginType = val;
      },
      // 路由跳转
      routerGo(pathName) {
        this.$router.push({ name: pathName, params: { login_type: this.loginType } });
      },
      // 发送短信验证码
      handleBtnClick_sendCode() {
        if (this.phoneClock) {
          return false;
        }
        if (this.regexPhone(this.ruleForm_c1.phone)) {
          this.$get(ajaxUrl.smsForgetSendSMS, {
            phone: this.ruleForm_c1.phone,
            smsType: 'tpl_resetpwd',
            code: this.ruleForm_c1.imgCode,
            sessionId: this.ruleForm_c1.uuid
          }).then(res => {
            if (res.is_send) {
              this.$message({
                message: '短信发送成功',
                type: 'success'
              });
              this.countDown();
            } else {
              this.$message({
                message: '短信已发送，请在' + res.second + '秒后重试',
                type: 'warning'
              });
              this.countDown(res.second);
            }
          });
        }
      },
      // 获取图形验证码
      getImgCode() {
        this.$get(ajaxUrl.authCode).then(res => {
          this.imgCodeSrc = res.imgBase;
          this.ruleForm_c1.uuid = res.sessionId;
        });
      },
      handleBtnClick_Submit_c1() {
        this.$refs.ruleForm_c1.validate((valid) => {
          if (valid) {
            this.$get(ajaxUrl.validateSMS, {
              phone: this.ruleForm_c1.phone,
              smsType: 'tpl_resetpwd',
              code: this.ruleForm_c1.code
            }).then(() => {
              this.companyRegStep = 2;
              this.img1 = iconYiwancheng;
              this.img2 = icon2Sel;
            });
          } else {
            return false;
          }
        });
      },
      handleBtnClick_Submit_c2() {
        this.$refs.ruleForm_c2.validate((valid) => {
          if (valid) {
            if (this.ruleForm_c2.password !== this.ruleForm_c2.confirmPwd) {
              this.$message({
                message: '您输入的密码不一致，请检查',
                type: 'error'
              });
              return false;
            }
            let data = {};
            data = {
              code: this.ruleForm_c1.code,
              phone: this.ruleForm_c1.phone,
              passWord: encrypt(this.ruleForm_c2.password),
              ensurePassWord: encrypt(this.ruleForm_c2.confirmPwd),
              sessionId: this.ruleForm_c1.uuid,
              picCode: this.ruleForm_c1.imgCode
            };
            this.$post(ajaxUrl.updatePassByPhone, data).then(() => {
              this.companyRegStep = 3;
              this.img1 = iconYiwancheng;
              this.img2 = iconYiwancheng;
              this.img3 = icon3Sel;
              this.regSuccess();
            });
          } else {
            return false;
          }
        });
      },
      // 注册成功，弹个框
      regSuccess() {
        this.timer = setInterval(() => {
          if (this.second <= 1) {
            clearInterval(this.timer);
            this.routerGo('login', this.login_type);
          }
          this.second--;
        }, 1000);
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "forget.sass"
</style>
